import React from "react";
import { MGTypography, TMGTypographyProps } from "../MGTypography/MGTypography";
import {
  MGMicrotextStyleDefinitions,
  TMGMicrotextStyleDefinitions,
} from "../../typography";

export type TMGMicrotextProps = TMGTypographyProps & {
  microtextStyleDefinition: TMGMicrotextStyleDefinitions;
};

export const MGMicrotext = ({ microtextStyleDefinition, ...props }: TMGMicrotextProps) => (
  <MGTypography
    {...props}
    componentName="mg-microtext"
    definition={MGMicrotextStyleDefinitions[microtextStyleDefinition]}
  />
);
